module.exports = __webpack_public_path__ + "img/category_28.dee89c32.png";